module.exports = __webpack_public_path__ + "media/images/ticket/ticket_destination_banner-0751d2db7ad47158386ce792b9a301ed.png";